import { Injectable, ɵɵdefineInjectable, Output, Input, EventEmitter, InjectionToken, ViewChild, TemplateRef, Injector } from '@angular/core';
import { Subject } from 'rxjs';
import { __extends, __values } from 'tslib';
import { takeUntil, startWith } from 'rxjs/operators';
import { AbstractControlDirective } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @param {?} value
 * @return {?}
 */
function coerceBooleanProperty(value) {
    return value != null && "" + value !== 'false';
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
var ShowOnDirtyErrorStateMatcher = /** @class */ (function () {
    function ShowOnDirtyErrorStateMatcher() {
    }
    /**
     * @param {?=} control
     * @param {?=} form
     * @return {?}
     */
    ShowOnDirtyErrorStateMatcher.prototype.isErrorState = /**
     * @param {?=} control
     * @param {?=} form
     * @return {?}
     */
    function (control, form) {
        return !!(control && control.invalid && (control.dirty || (form && form.submitted)));
    };
    ShowOnDirtyErrorStateMatcher.decorators = [
        { type: Injectable }
    ];
    return ShowOnDirtyErrorStateMatcher;
}());
/**
 * Provider that defines how form controls behave with regards to displaying error messages.
 */
var ErrorStateMatcher = /** @class */ (function () {
    function ErrorStateMatcher() {
    }
    /**
     * @param {?=} control
     * @param {?=} form
     * @return {?}
     */
    ErrorStateMatcher.prototype.isErrorState = /**
     * @param {?=} control
     * @param {?=} form
     * @return {?}
     */
    function (control, form) {
        return !!(control && control.invalid && (control.touched || (form && form.submitted)));
    };
    ErrorStateMatcher.decorators = [
        { type: Injectable, args: [{ providedIn: 'root' },] }
    ];
    /** @nocollapse */ ErrorStateMatcher.ngInjectableDef = ɵɵdefineInjectable({ factory: function ErrorStateMatcher_Factory() { return new ErrorStateMatcher(); }, token: ErrorStateMatcher, providedIn: "root" });
    return ErrorStateMatcher;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
// A counter for the unique id for the form element
/** @type {?} */
var _idCounter = 0;
/**
 * @abstract
 * @template T
 */
var VxFormComponent = /** @class */ (function () {
    function VxFormComponent(cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) {
        this.cdr = cdr;
        this.errorStateMatcher = errorStateMatcher;
        this.ngControl = ngControl;
        this.parentForm = parentForm;
        this.parentFormGroup = parentFormGroup;
        this.errorState = false;
        this.focused = false;
        this.focusedChange = new EventEmitter();
        this.valueChange = new EventEmitter();
        this._disabled = false;
        this._required = false;
        this._id = "vx-form-element-" + _idCounter++;
        this.onDestroy$ = new Subject();
        this.onTouchFn = (/**
         * @return {?}
         */
        function () {
        });
        this.onChangeFn = (/**
         * @param {?} _
         * @return {?}
         */
        function (_) {
        });
    }
    Object.defineProperty(VxFormComponent.prototype, "id", {
        get: /**
         * @return {?}
         */
        function () {
            return this._id;
        },
        set: /**
         * @param {?} id
         * @return {?}
         */
        function (id) {
            if (id !== this._id) {
                this._id = id;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VxFormComponent.prototype, "value", {
        /**
         * The value of this form component
         */
        get: /**
         * The value of this form component
         * @return {?}
         */
        function () {
            return this.getNativeValue();
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.handleValueSet(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VxFormComponent.prototype, "disabled", {
        /** Whether the component is disabled */
        get: /**
         * Whether the component is disabled
         * @return {?}
         */
        function () {
            return this._disabled;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this._disabled) {
                this._disabled = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(VxFormComponent.prototype, "required", {
        /** Whether the component is required */
        get: /**
         * Whether the component is required
         * @return {?}
         */
        function () {
            return this._required;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this._required) {
                this._required = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {?} fn
     * @return {?}
     */
    VxFormComponent.prototype.registerOnChange = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        var _this = this;
        this.onChangeFn = (/**
         * @param {?} obj
         * @return {?}
         */
        function (obj) {
            _this.lastRegisteredValue = obj;
            fn(obj);
        });
    };
    /**
     * @param {?} fn
     * @return {?}
     */
    VxFormComponent.prototype.registerOnTouched = /**
     * @param {?} fn
     * @return {?}
     */
    function (fn) {
        this.onTouchFn = fn;
    };
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    VxFormComponent.prototype.setDisabledState = /**
     * @param {?} isDisabled
     * @return {?}
     */
    function (isDisabled) {
        this.disabled = isDisabled;
        this.cdr.markForCheck();
    };
    /**
     * @param {?} obj
     * @return {?}
     */
    VxFormComponent.prototype.writeValue = /**
     * @param {?} obj
     * @return {?}
     */
    function (obj) {
        this.lastRegisteredValue = obj;
        this.setValueFromNative(obj);
    };
    /**
     * @param {?} hasFocus
     * @return {?}
     */
    VxFormComponent.prototype._setHasFocus = /**
     * @param {?} hasFocus
     * @return {?}
     */
    function (hasFocus) {
        this.focused = hasFocus;
        this.focusedChange.emit(hasFocus);
        this.cdr.markForCheck();
    };
    /**
     * @return {?}
     */
    VxFormComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        // this._lastNativeValue = this.value;
    };
    /**
     * @return {?}
     */
    VxFormComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    /**
     * @return {?}
     */
    VxFormComponent.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        if (this.ngControl) {
            // We need to re-evaluate this on every change detection cycle, because there are some
            // error triggers that we can't subscribe to (e.g. parent form submissions). This means
            // that whatever logic is in here has to be super lean or we risk destroying the performance.
            this.checkErrorState();
        }
        // We need to dirty-check the native element's value, because there are some cases where
        // we won't be notified when it changes (e.g. the consumer isn't using forms or they're
        // updating the value using `emitEvent: false`).
        this._dirtyCheckNativeValue();
    };
    /**
     * @protected
     * @return {?}
     */
    VxFormComponent.prototype.checkErrorState = /**
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var oldState = this.errorState;
        /** @type {?} */
        var parent = this.parentFormGroup || this.parentForm;
        /** @type {?} */
        var control = this.ngControl ? (/** @type {?} */ (this.ngControl.control)) : undefined;
        /** @type {?} */
        var newState = this.errorStateMatcher.isErrorState(control, parent);
        if (newState !== oldState) {
            this.errorState = newState;
            this.cdr.markForCheck();
        }
    };
    /**
     * @protected
     * @param {?} value
     * @return {?}
     */
    VxFormComponent.prototype.setValueFromNative = /**
     * @protected
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.value = value;
        this.valueChange.emit(value);
        this.onTouchFn();
    };
    /**
     * @protected
     * @return {?}
     */
    VxFormComponent.prototype._dirtyCheckNativeValue = /**
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var val = this.value;
        if (this._lastNativeValue !== val) {
            this._lastNativeValue = val;
            this.setValueFromNative(val);
        }
    };
    /**
     * @protected
     * @param {?} value
     * @return {?}
     */
    VxFormComponent.prototype.handleValueSet = /**
     * @protected
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value !== this.value) {
            this._lastNativeValue = value;
            this.setNativeValue(value);
            // If the ngControl isn't aware of this value make it aware
            if (this.lastRegisteredValue !== value) {
                this.onChangeFn(value);
            }
            this.cdr.markForCheck();
        }
    };
    VxFormComponent.propDecorators = {
        focusedChange: [{ type: Output }],
        valueChange: [{ type: Output }],
        id: [{ type: Input }],
        value: [{ type: Input }],
        disabled: [{ type: Input }],
        required: [{ type: Input }]
    };
    return VxFormComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} classToMix
 * @return {?}
 */
function formComponentMixin(classToMix) {
    return /** @class */ (function (_super) {
        __extends(class_1, _super);
        function class_1() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.errorState = false;
            _this.stateChanges = new Subject();
            return _this;
        }
        /**
         * @return {?}
         */
        class_1.prototype.checkErrorState = /**
         * @return {?}
         */
        function () {
            // TODO: How to fix typings on this?
            /** @type {?} */
            var that = (/** @type {?} */ (this));
            /** @type {?} */
            var oldState = this.errorState;
            /** @type {?} */
            var parent = that._parentFormGroup || that._parentForm;
            /** @type {?} */
            var matcher = that.errorStateMatcher;
            /** @type {?} */
            var control = that.ngControl ? (/** @type {?} */ (that.ngControl.control)) : undefined;
            /** @type {?} */
            var newState = matcher.isErrorState(control, parent);
            if (newState !== oldState) {
                this.errorState = newState;
                this.stateChanges.next();
            }
        };
        return class_1;
    }(classToMix));
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template T
 * @param {?} items
 * @param {?} startIndex
 * @param {?} testFunction
 * @param {?=} forward
 * @return {?}
 */
function findInArrayByDirection(items, startIndex, testFunction, forward) {
    if (forward === void 0) { forward = true; }
    /** @type {?} */
    var length = items.length;
    for (var i = startIndex; forward ? i < length : i >= 0; forward ? i++ : i--) {
        /** @type {?} */
        var item = items[i];
        if (testFunction(item)) {
            return { item: item, idx: i };
        }
    }
    return;
}
/**
 * @param {?} numToClamp
 * @param {?} min
 * @param {?} max
 * @return {?}
 */
function clampNumber(numToClamp, min, max) {
    return Math.max(Math.min(numToClamp, max), min);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var AbstractVxFormFieldDirective = /** @class */ (function (_super) {
    __extends(AbstractVxFormFieldDirective, _super);
    function AbstractVxFormFieldDirective(elementRef, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) {
        var _this = _super.call(this, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) || this;
        _this.elementRef = elementRef;
        /**
         * Notifies that our state may have changed, so that the parent field may respond accordingly
         */
        _this.stateChanges = new Subject();
        _this._placeholder = '';
        _this._label = '';
        _this._hideRequiredMarker = false;
        // Every time the cdr is told to check for changes we notify that our state may have changed
        /** @type {?} */
        var oldCheck = cdr.markForCheck.bind(cdr);
        cdr.markForCheck = (/**
         * @return {?}
         */
        function () {
            _this.stateChanges.next();
            oldCheck();
        });
        return _this;
    }
    Object.defineProperty(AbstractVxFormFieldDirective.prototype, "placeholder", {
        get: /**
         * @return {?}
         */
        function () {
            return this._placeholder;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._placeholder = value;
            this.stateChanges.next();
            this.cdr.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxFormFieldDirective.prototype, "label", {
        get: /**
         * @return {?}
         */
        function () {
            return this._label;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._label = value;
            this.stateChanges.next();
            this.cdr.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxFormFieldDirective.prototype, "hideRequiredMarker", {
        /** Whether or not to hide the required marker */
        get: /**
         * Whether or not to hide the required marker
         * @return {?}
         */
        function () {
            return this._hideRequiredMarker;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this._hideRequiredMarker) {
                this.cdr.markForCheck();
                this.stateChanges.next();
            }
        },
        enumerable: true,
        configurable: true
    });
    AbstractVxFormFieldDirective.propDecorators = {
        placeholder: [{ type: Input }],
        label: [{ type: Input }],
        hideRequiredMarker: [{ type: Input }]
    };
    return AbstractVxFormFieldDirective;
}(VxFormComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
AbstractVxFormFieldComponent = /** @class */ (function () {
    function AbstractVxFormFieldComponent(cdr) {
        this.cdr = cdr;
        this.onDestroy$ = new Subject();
    }
    /**
     * @return {?}
     */
    AbstractVxFormFieldComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.field) {
            throw new Error(this.componentName + " without a " + this.fieldDirectiveName + " directive");
        }
        this.field.stateChanges.pipe(takeUntil(this.onDestroy$)).subscribe((/**
         * @return {?}
         */
        function () {
            _this.cdr.markForCheck();
        }));
    };
    /**
     * @return {?}
     */
    AbstractVxFormFieldComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    return AbstractVxFormFieldComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T
 */
var AbstractVxRadioButtonComponent = /** @class */ (function () {
    function AbstractVxRadioButtonComponent(cdr, group) {
        this.cdr = cdr;
        this.group = group;
        this.checkedChange = new EventEmitter();
        this._disabled = false;
        this._name = '';
        this.onDestroy$ = new Subject();
        this.wasChecked = false;
    }
    Object.defineProperty(AbstractVxRadioButtonComponent.prototype, "disabled", {
        /** Whether the radio button is disabled */
        get: /**
         * Whether the radio button is disabled
         * @return {?}
         */
        function () {
            return this._disabled || this.group.disabled;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this._disabled) {
                this._disabled = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxRadioButtonComponent.prototype, "checked", {
        /** Whether the radio button is disabled */
        get: /**
         * Whether the radio button is disabled
         * @return {?}
         */
        function () {
            return this.value === this.group.value;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value && value !== this.checked) {
                this.group.value = this.value;
            }
            else if (!value && value !== this.checked) {
                this.group.value = (/** @type {?} */ ((/** @type {?} */ (undefined))));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxRadioButtonComponent.prototype, "name", {
        get: /**
         * @return {?}
         */
        function () {
            return this._name || this.group.name;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxRadioButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        if (!this.group) {
            throw new Error(this.componentName + " without a surrounding group component");
        }
        // Watches for the groups value changes to emit changes to this field's being checked
        this.group.valueChange.pipe(takeUntil(this.onDestroy$), startWith(this.group.value)).subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== value && _this.wasChecked) {
                _this.wasChecked = false;
                _this.checkedChange.emit(false);
            }
            else if (value === _this.value && !_this.wasChecked) {
                _this.wasChecked = true;
                _this.checkedChange.emit(true);
            }
        }));
    };
    /**
     * @return {?}
     */
    AbstractVxRadioButtonComponent.prototype._markForCheck = /**
     * @return {?}
     */
    function () {
        this.cdr.markForCheck();
    };
    /**
     * @return {?}
     */
    AbstractVxRadioButtonComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    AbstractVxRadioButtonComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('checked' in changes) {
            // In case the checked input was set before the value input.
            if (this.checked !== changes.checked.currentValue) {
                this.checked = changes.checked.currentValue;
            }
        }
    };
    AbstractVxRadioButtonComponent.propDecorators = {
        checkedChange: [{ type: Output }],
        value: [{ type: Input }],
        disabled: [{ type: Input }],
        checked: [{ type: Input }],
        name: [{ type: Input }]
    };
    return AbstractVxRadioButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var uniqueId = 0;
/**
 * @abstract
 * @template T
 */
var AbstractVxRadioGroupComponent = /** @class */ (function (_super) {
    __extends(AbstractVxRadioGroupComponent, _super);
    function AbstractVxRadioGroupComponent(cdr, errorStateMatcher, control, parentForm, parentFormGroup) {
        var _this = _super.call(this, cdr, errorStateMatcher, control, parentForm, parentFormGroup) || this;
        _this._name = "vxradio-" + ++uniqueId;
        if (control) {
            control.valueAccessor = _this;
        }
        return _this;
    }
    Object.defineProperty(AbstractVxRadioGroupComponent.prototype, "name", {
        get: /**
         * @return {?}
         */
        function () {
            return this._name;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this._name = value;
            this.cdr.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxRadioGroupComponent.prototype._next = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var buttons = this.buttons.toArray();
        /** @type {?} */
        var selectedIndex = this.getSelectedIndex();
        if (selectedIndex === buttons.length - 1) {
            selectedIndex = 0;
        }
        else {
            selectedIndex++;
        }
        this._handleButtonSelect(buttons[selectedIndex].value);
    };
    /**
     * @return {?}
     */
    AbstractVxRadioGroupComponent.prototype._previous = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var buttons = this.buttons.toArray();
        /** @type {?} */
        var selectedIndex = this.getSelectedIndex();
        if (selectedIndex === 0) {
            selectedIndex = buttons.length - 1;
        }
        else {
            selectedIndex--;
        }
        this._handleButtonSelect(buttons[selectedIndex].value);
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    AbstractVxRadioGroupComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if (this.buttons) {
            // Ensures all changes to the group component are reflected on the underlying buttons
            this.buttons.forEach((/**
             * @param {?} button
             * @return {?}
             */
            function (button) { return button._markForCheck(); }));
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AbstractVxRadioGroupComponent.prototype._handleButtonSelect = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        this.setValueFromNative(value);
    };
    /**
     * @protected
     * @return {?}
     */
    AbstractVxRadioGroupComponent.prototype.getNativeValue = /**
     * @protected
     * @return {?}
     */
    function () {
        return this._value;
    };
    /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    AbstractVxRadioGroupComponent.prototype.setNativeValue = /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    function (val) {
        this._value = val;
    };
    /**
     * @protected
     * @return {?}
     */
    AbstractVxRadioGroupComponent.prototype.getSelectedIndex = /**
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var buttons = this.buttons.toArray();
        for (var i = 0; i < buttons.length; i++) {
            if (buttons[i].value === this.value) {
                return i;
            }
        }
        return -1;
    };
    AbstractVxRadioGroupComponent.propDecorators = {
        name: [{ type: Input }]
    };
    return AbstractVxRadioGroupComponent;
}(VxFormComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var VX_RADIO_GROUP_TOKEN = new InjectionToken('VX_RADIO_GROUP_TOKEN_INTERNAL');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template E
 */
var  /**
 * @abstract
 * @template E
 */
AbstractVxAttachMenuDirective = /** @class */ (function () {
    function AbstractVxAttachMenuDirective(el) {
        this.el = el;
    }
    /**
     * @return {?}
     */
    AbstractVxAttachMenuDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.menu) {
            throw new Error(this.directiveName + " without a menu");
        }
        this.menu.attachedTo = this.el.nativeElement;
    };
    return AbstractVxAttachMenuDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var _vxItemIdCounter = 0;
/**
 * @abstract
 * @template T
 */
var AbstractVxItemComponent = /** @class */ (function () {
    function AbstractVxItemComponent(cdr, _menu) {
        this.cdr = cdr;
        this._menu = _menu;
        /**
         * Emits when the item is selected
         */
        this.select = new EventEmitter();
        this._id = "vx-item-" + _vxItemIdCounter++;
        this.onDestroy$ = new Subject();
        this._disabled = false;
    }
    Object.defineProperty(AbstractVxItemComponent.prototype, "value", {
        get: /**
         * @return {?}
         */
        function () {
            return this._value;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (this._transparentParent) {
                this._transparentParent.value = value;
            }
            if (value !== this.value) {
                this._value = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxItemComponent.prototype, "disabled", {
        get: /**
         * @return {?}
         */
        function () {
            return this._disabled;
        },
        set: /**
         * @param {?} disabled
         * @return {?}
         */
        function (disabled) {
            disabled = coerceBooleanProperty(disabled);
            if (this._transparentParent) {
                this._transparentParent.disabled = disabled;
            }
            if (disabled !== this.disabled) {
                this._disabled = disabled;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxItemComponent.prototype, "_transparentChild", {
        get: /**
         * @return {?}
         */
        function () {
            return this.__transparentChild;
        },
        set: /**
         * @param {?} wrappedItem
         * @return {?}
         */
        function (wrappedItem) {
            if (!wrappedItem) {
                return;
            }
            this.value = wrappedItem.value;
            this.disabled = wrappedItem.disabled;
            wrappedItem._transparentParent = this;
            this.__transparentChild = wrappedItem;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxItemComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    /**
     * @return {?}
     */
    AbstractVxItemComponent.prototype._handleSelect = /**
     * @return {?}
     */
    function () {
        if (this._transparentChild) {
            this._transparentChild._handleSelect();
        }
        if (this.disabled) {
            return;
        }
        this.select.emit(this.value);
        if (this._menu) {
            this._menu.itemSelect.emit(this.value);
        }
    };
    AbstractVxItemComponent.propDecorators = {
        _template: [{ type: ViewChild, args: [TemplateRef, { static: true },] }],
        select: [{ type: Output }],
        value: [{ type: Input }],
        disabled: [{ type: Input }],
        _transparentChild: [{ type: Input }]
    };
    return AbstractVxItemComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T, E
 */
var AbstractVxMenuComponent = /** @class */ (function () {
    function AbstractVxMenuComponent(cdr) {
        this.cdr = cdr;
        /**
         * Event thrown when the menu's visibility changes. The value is the visibility (true or false)
         */
        this.visibleChange = new EventEmitter();
        /**
         * Event thrown when one of the menu's items are selected.  The value is the item's value
         */
        this.itemSelect = new EventEmitter();
        this._active = false;
        this.onDestroy$ = new Subject();
        this._defaultText = '';
        this._visible = false;
        this._positionStrategy = [
            {
                menuX: 'left',
                menuY: 'top',
                attachedX: 'left',
                attachedY: 'bottom',
                offsetX: 0,
                offsetY: 10
            },
            {
                menuX: 'left',
                menuY: 'bottom',
                attachedX: 'left',
                attachedY: 'top',
                offsetX: 0,
                offsetY: -10,
                className: 'vx-menu-attached-top'
            },
            {
                menuX: 'right',
                menuY: 'top',
                attachedX: 'right',
                attachedY: 'bottom',
                offsetX: 0,
                offsetY: 10
            },
            {
                menuX: 'right',
                menuY: 'bottom',
                attachedX: 'right',
                attachedY: 'top',
                offsetX: 0,
                offsetY: -10,
                className: 'vx-menu-attached-top'
            }
        ];
        this._width = 'auto';
        this._maxHeight = 200;
    }
    Object.defineProperty(AbstractVxMenuComponent.prototype, "width", {
        get: /**
         * @return {?}
         */
        function () { return this._width; },
        set: /**
         * @param {?} width
         * @return {?}
         */
        function (width) {
            /** @type {?} */
            var numWidth = +width;
            if (!isNaN(numWidth)) {
                width = numWidth;
            }
            if (width !== this.width) {
                this._width = width;
                this.position();
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxMenuComponent.prototype, "maxHeight", {
        get: /**
         * @return {?}
         */
        function () { return this._maxHeight; },
        set: /**
         * @param {?} maxHeight
         * @return {?}
         */
        function (maxHeight) {
            /** @type {?} */
            var numHeight = +maxHeight;
            if (!isNaN(numHeight)) {
                maxHeight = numHeight;
            }
            if (maxHeight !== this.maxHeight) {
                this._maxHeight = maxHeight;
                this.position();
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxMenuComponent.prototype, "defaultText", {
        get: /**
         * @return {?}
         */
        function () {
            return this._defaultText;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this._defaultText) {
                this._defaultText = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxMenuComponent.prototype, "visible", {
        /** Whether the dropdown is visible */
        get: /**
         * Whether the dropdown is visible
         * @return {?}
         */
        function () {
            return this._visible;
        },
        set: /**
         * @param {?} visible
         * @return {?}
         */
        function (visible) {
            visible = coerceBooleanProperty(visible);
            if (visible !== this._visible) {
                this._visible = visible;
                this.visibleChange.emit(visible);
                if (visible) {
                    this.show();
                }
                else {
                    this.hide();
                }
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxMenuComponent.prototype, "positionStrategy", {
        get: /**
         * @return {?}
         */
        function () {
            return this._positionStrategy;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value !== this.positionStrategy) {
                this._positionStrategy = value;
                this.position();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxMenuComponent.prototype, "attachedTo", {
        get: /**
         * @return {?}
         */
        function () {
            return this._attachedTo;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this._attachedTo) {
                this._attachedTo = value;
                this.position();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxMenuComponent.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.visible = !this.visible;
    };
    /**
     * @return {?}
     */
    AbstractVxMenuComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.onDestroy$.next();
        this.onDestroy$.complete();
    };
    /**
     * @return {?}
     */
    AbstractVxMenuComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.items.changes.pipe(startWith(null), takeUntil(this.onDestroy$)).subscribe((/**
         * @return {?}
         */
        function () {
            _this.onItemsChanged();
        }));
    };
    /**
     * @protected
     * @param {?=} retry
     * @return {?}
     */
    AbstractVxMenuComponent.prototype.position = /**
     * @protected
     * @param {?=} retry
     * @return {?}
     */
    function (retry) {
        var _this = this;
        var e_1, _a;
        if (retry === void 0) { retry = 0; }
        if (retry === 5) {
            throw new Error('Failed to Position Vx-Menu');
        }
        if (!this.visible) {
            return;
        }
        /** @type {?} */
        var attachedPos = this.getAttachedPosition();
        /** @type {?} */
        var menuPos = this.getMenuPosition();
        /** @type {?} */
        var viewport = this.getViewportSize();
        // If we can't yet get the dimensions wait a bit then retry
        if (!attachedPos || !menuPos || !viewport) {
            setTimeout((/**
             * @return {?}
             */
            function () {
                _this.position(retry++);
            }), 50);
            return;
        }
        /** @type {?} */
        var desiredHeight = this.getExpectedHeight(menuPos);
        /** @type {?} */
        var desiredWidth = this.width === 'auto' ? menuPos.width : (this.width === 'match' ? attachedPos.width : this.width);
        /** @type {?} */
        var foundStrategy;
        /** @type {?} */
        var foundPosition;
        /** @type {?} */
        var isAutoWidth = false;
        /** @type {?} */
        var positionOverlap;
        try {
            for (var _b = __values(this.positionStrategy), _c = _b.next(); !_c.done; _c = _b.next()) {
                var strategy = _c.value;
                /** @type {?} */
                var xPos = strategy.offsetX;
                /** @type {?} */
                var yPos = strategy.offsetY;
                // Offset the menu position based on our strategy
                xPos -= strategy.menuX === 'center' ? desiredWidth / 2 : (strategy.menuX === 'right' ? desiredWidth : 0);
                yPos -= strategy.menuY === 'center' ? desiredHeight / 2 : (strategy.menuY === 'bottom' ? desiredHeight : 0);
                // Offset the menu position based on our attached object
                xPos += strategy.attachedX === 'left' ? attachedPos.x :
                    (strategy.attachedX === 'center' ? attachedPos.x + (attachedPos.width / 2) : attachedPos.x + attachedPos.width);
                yPos += strategy.attachedY === 'top' ? attachedPos.y :
                    (strategy.attachedY === 'center' ? attachedPos.y + (attachedPos.height / 2) : attachedPos.y + attachedPos.height);
                // Calculate how much this position overlaps the viewport with a desired margin
                /** @type {?} */
                var desiredMargin = 10;
                /** @type {?} */
                var overlap = 0;
                if (xPos < desiredMargin) {
                    overlap += desiredMargin - xPos;
                }
                if (xPos + desiredWidth + desiredMargin > viewport.width) {
                    overlap += xPos + desiredWidth + desiredMargin - viewport.width;
                }
                if (yPos < desiredMargin) {
                    overlap += desiredMargin - yPos;
                }
                if (yPos + desiredHeight + desiredMargin > viewport.height) {
                    overlap += yPos + desiredHeight + desiredMargin - viewport.height;
                }
                // If this strategy has less overlap than the previous strategy use this
                if (!foundPosition || !positionOverlap || overlap < positionOverlap) {
                    foundStrategy = strategy;
                    foundPosition = { x: xPos, y: yPos, width: desiredWidth, height: desiredHeight };
                    isAutoWidth = this.width === 'auto';
                    positionOverlap = overlap;
                }
                // If there is no overlap select this strategy
                if (overlap === 0) {
                    break;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (foundPosition) {
            this.setNativePosition(foundPosition, isAutoWidth);
        }
        if (foundStrategy) {
            this.lastPosition = foundStrategy;
            if (foundStrategy.className !== this._positionStrategyClass) {
                this._positionStrategyClass = foundStrategy.className;
                this.cdr.detectChanges();
            }
        }
    };
    /**
     * @protected
     * @return {?}
     */
    AbstractVxMenuComponent.prototype.onItemsChanged = /**
     * @protected
     * @return {?}
     */
    function () {
        var _this = this;
        this.cdr.markForCheck();
        if (!this.visible) {
            return;
        }
        // Wait some time to allow the re-render, then reposition.
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this.position();
        }), 30);
    };
    AbstractVxMenuComponent.propDecorators = {
        visibleChange: [{ type: Output }],
        itemSelect: [{ type: Output }],
        width: [{ type: Input }],
        maxHeight: [{ type: Input }],
        defaultText: [{ type: Input }],
        visible: [{ type: Input }],
        positionStrategy: [{ type: Input }],
        attachedTo: [{ type: Input }]
    };
    return AbstractVxMenuComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var VX_MENU_TOKEN = new InjectionToken('VX_MENU_TOKEN');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var AUTOCOMPLETE_FILTER_FUNCTION = new InjectionToken('AUTOCOMPLETE_FILTER_FUNCTION');
/** @type {?} */
var defaultAutocompleteFilterFunction = (/**
 * @param {?} items
 * @param {?} searchText
 * @param {?} selectedItems
 * @return {?}
 */
function (items, searchText, selectedItems) {
    searchText = searchText.toUpperCase();
    /** @type {?} */
    var scores = {};
    // The scores are negative based.  The lower the score the worse you did
    return items.filter((/**
     * @param {?} item
     * @return {?}
     */
    function (item) {
        var e_1, _a;
        // Remove the already selected items (for the case of multiple selection autocomplete)
        if (selectedItems && selectedItems.includes(item.value)) {
            return false;
        }
        /** @type {?} */
        var itemText = item.getTextContent().toUpperCase();
        /** @type {?} */
        var itemTextLength = itemText.length;
        // A super simple fuzzy search, checks if the characters are in the item text in the same order
        /** @type {?} */
        var idx = -1;
        /** @type {?} */
        var score = 0;
        try {
            for (var searchText_1 = __values(searchText), searchText_1_1 = searchText_1.next(); !searchText_1_1.done; searchText_1_1 = searchText_1.next()) {
                var char = searchText_1_1.value;
                /** @type {?} */
                var foundChar = false;
                for (var i = idx + 1; i < itemTextLength; i++) {
                    if (itemText[i] === char) {
                        foundChar = true;
                        // When this character is the beginning of a word increase the score
                        if (i === 0 || itemText[i - 1] === ' ') {
                            score += i === 0 ? 2 : 1;
                        }
                        else {
                            // Otherwise subtract the distance between the matches
                            score -= i - idx;
                        }
                        idx = i;
                        break;
                    }
                }
                if (!foundChar) {
                    return false;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (searchText_1_1 && !searchText_1_1.done && (_a = searchText_1.return)) _a.call(searchText_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        scores[item._id] = score;
        return true;
    })).sort((/**
     * @param {?} a
     * @param {?} b
     * @return {?}
     */
    function (a, b) {
        /** @type {?} */
        var scoreA = scores[a._id] || 0;
        /** @type {?} */
        var scoreB = scores[b._id] || 0;
        return scoreA < scoreB ? 1 : scoreA === scoreB ? 0 : -1;
    }));
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template T, I
 */
var AbstractVxAutocompleteComponent = /** @class */ (function (_super) {
    __extends(AbstractVxAutocompleteComponent, _super);
    function AbstractVxAutocompleteComponent(cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup, filterFunction) {
        var _this = _super.call(this, cdr, errorStateMatcher, ngControl, parentForm, parentFormGroup) || this;
        _this.search = new EventEmitter();
        _this.itemSelect = new EventEmitter();
        _this._filteredItems = [];
        _this._positionStrategy = [{
                menuX: 'left',
                menuY: 'top',
                attachedX: 'left',
                attachedY: 'bottom',
                offsetX: 0,
                offsetY: -2.5,
                className: 'vx-autocomplete-menu-bottom'
            }, {
                menuX: 'left',
                menuY: 'bottom',
                attachedX: 'left',
                attachedY: 'top',
                offsetX: 0,
                offsetY: -2.5,
                className: 'vx-menu-attached-top'
            }];
        _this._defaultText = 'No results found.';
        _this._multiple = false;
        _this._filterFunction = defaultAutocompleteFilterFunction;
        _this._label = '';
        _this._searchable = true;
        _this.searchText = '';
        _this.keyedItems = new Map();
        /**
         * There are a number of things that can cause the need to filter,
         * so this flag tells us we need to filter this round.
         */
        _this.needsFilter = false;
        /**
         * If set to true means we should verify the value is an array and that all of the items exist,
         * or if not multiple verify we have an item for the value.
         */
        _this.shouldVerifyValue = false;
        if (ngControl) {
            ngControl.valueAccessor = _this;
        }
        if (filterFunction) {
            _this.filterFunction = filterFunction;
        }
        return _this;
    }
    Object.defineProperty(AbstractVxAutocompleteComponent.prototype, "defaultText", {
        /** The text to show when there are no items */
        get: /**
         * The text to show when there are no items
         * @return {?}
         */
        function () {
            return this._defaultText;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this._defaultText) {
                this._defaultText = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxAutocompleteComponent.prototype, "multiple", {
        get: /**
         * @return {?}
         */
        function () {
            return this._multiple;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this._multiple) {
                this._multiple = value;
                this.shouldVerifyValue = true;
                this.filter();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxAutocompleteComponent.prototype, "filterFunction", {
        get: /**
         * @return {?}
         */
        function () {
            return this._filterFunction;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value && value !== this.filterFunction) {
                this._filterFunction = value;
                this.filter();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxAutocompleteComponent.prototype, "placeholder", {
        get: /**
         * @return {?}
         */
        function () {
            if (this._placeholder) {
                return this._placeholder;
            }
            else {
                /** @type {?} */
                var item = this.multiple ? null : this.getItemByValue((/** @type {?} */ (this.value)));
                if (item) {
                    return item.getTextContent();
                }
                else {
                    return this.searchable ? 'Search...' : 'Select...';
                }
            }
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this._placeholder) {
                this._placeholder = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxAutocompleteComponent.prototype, "label", {
        get: /**
         * @return {?}
         */
        function () {
            return this._label;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            if (value !== this.label) {
                this._label = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxAutocompleteComponent.prototype, "searchable", {
        get: /**
         * @return {?}
         */
        function () {
            return this._searchable;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this._searchable) {
                this._searchable = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxAutocompleteComponent.prototype, "_selectedItems", {
        get: /**
         * @return {?}
         */
        function () {
            var _this = this;
            if (this.multiple) {
                /** @type {?} */
                var val = this.value;
                if (!val || !(val instanceof Array)) {
                    val = [];
                }
                return val.map((/**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) { return _this.getItemByValue(value); }));
            }
            else {
                return [];
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._items.changes.pipe(startWith(null), takeUntil(this.onDestroy$)).subscribe((/**
         * @return {?}
         */
        function () {
            _this.keyedItems.clear();
            _this._items.forEach((/**
             * @param {?} item
             * @return {?}
             */
            function (item) {
                _this.keyedItems.set(item.value, item);
            }));
            // Verify all
            _this.shouldVerifyValue = true;
            _this.filter();
        }));
    };
    /**
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this._field.valueChange.pipe(takeUntil(this.onDestroy$)).subscribe((/**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            _this.handleFieldSearchChange(value);
        }));
        this._field.focusedChange.pipe(takeUntil(this.onDestroy$)).subscribe((/**
         * @param {?} focused
         * @return {?}
         */
        function (focused) {
            _this._handleFieldFocusChange(focused);
        }));
        this._menu.itemSelect.pipe(takeUntil(this.onDestroy$)).subscribe((/**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            _this.handleItemSelect(val);
        }));
        this._menu.visibleChange.pipe(takeUntil(this.onDestroy$)).subscribe((/**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            _this.handleMenuVisibilityChange(val);
        }));
    };
    /**
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.ngDoCheck = /**
     * @return {?}
     */
    function () {
        // Before running change detection, if we need to filter we should filter.
        if (this.needsFilter) {
            this.filter(true);
        }
        _super.prototype.ngDoCheck.call(this);
    };
    /**
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype._showMenu = /**
     * @return {?}
     */
    function () {
        this.onTouchFn();
        if (!this._menu.visible) {
            this._menu.visible = true;
        }
    };
    /**
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype._hideMenu = /**
     * @return {?}
     */
    function () {
        if (this._menu.visible) {
            this._menu.visible = false;
        }
    };
    /**
     * @param {?} value
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype._removeItem = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (this.multiple) {
            /** @type {?} */
            var existing = (/** @type {?} */ (this.value));
            /** @type {?} */
            var idx = existing.indexOf(value);
            if (idx !== -1) {
                existing.splice(idx, 1);
            }
            this.setValueFromNative(existing);
        }
    };
    /**
     * @param {?} focused
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype._handleFieldFocusChange = /**
     * @param {?} focused
     * @return {?}
     */
    function (focused) {
        if (focused && !this._menu.visible) {
            this._showMenu();
            this._field.value = '';
        }
        else if (!focused && !this._menu._active && this._menu.visible) {
            this._hideMenu();
        }
        else if (!focused && this._menu._active) {
            this._field.focus();
        }
    };
    /**
     * @protected
     * @param {?=} runImmediately
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.filter = /**
     * @protected
     * @param {?=} runImmediately
     * @return {?}
     */
    function (runImmediately) {
        var _this = this;
        if (runImmediately === void 0) { runImmediately = false; }
        if (!runImmediately) {
            this.needsFilter = true;
            this.cdr.markForCheck();
            return;
        }
        // In the case that something triggers a filter before we have items
        if (!this._items) {
            return;
        }
        if (this.shouldVerifyValue && this.multiple) {
            if (!this.value || !(this.value instanceof Array)) {
                this.setValueFromNative([]);
            }
            else {
                // Ensure the selected value is still in the list of items
                /** @type {?} */
                var newVals_1 = [];
                /** @type {?} */
                var changed_1 = false;
                this.value.forEach((/**
                 * @param {?} value
                 * @return {?}
                 */
                function (value) {
                    if (!_this.getItemByValue(value)) {
                        changed_1 = true;
                    }
                    else {
                        newVals_1.push(value);
                    }
                }));
                if (changed_1) {
                    this.setValueFromNative(newVals_1);
                }
            }
        }
        else if (this.shouldVerifyValue && !this.multiple && this.value) {
            /** @type {?} */
            var item = this.getItemByValue((/** @type {?} */ (this.value)));
            if (!item) {
                this.setValueFromNative((/** @type {?} */ ((/** @type {?} */ (undefined)))));
            }
        }
        this.shouldVerifyValue = false;
        this.needsFilter = false;
        this._filteredItems = (/** @type {?} */ (this.filterFunction(this._items.toArray(), this.searchText, this.multiple ? (/** @type {?} */ (this.value)) : undefined)));
    };
    /**
     * @protected
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.getNativeValue = /**
     * @protected
     * @return {?}
     */
    function () {
        return this._value;
    };
    /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.setNativeValue = /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    function (val) {
        this._value = val;
    };
    /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.handleItemSelect = /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    function (val) {
        this.itemSelect.emit(val);
        if (this.multiple) {
            /** @type {?} */
            var existing = this.value;
            ((/** @type {?} */ (existing))).push(val);
            this.setValueFromNative(this.value);
        }
        else {
            this.setValueFromNative(val);
        }
        this.handleFieldSearchChange('', false);
    };
    /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.getItemByValue = /**
     * @protected
     * @param {?} val
     * @return {?}
     */
    function (val) {
        if (!this._items || !val) {
            return;
        }
        return this.keyedItems.get(val);
    };
    /**
     * @protected
     * @param {?} search
     * @param {?=} showMenu
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.handleFieldSearchChange = /**
     * @protected
     * @param {?} search
     * @param {?=} showMenu
     * @return {?}
     */
    function (search, showMenu) {
        if (showMenu === void 0) { showMenu = true; }
        this.searchText = search;
        this.search.emit(search);
        this.filter();
        if (showMenu) {
            this._showMenu();
        }
    };
    /**
     * @protected
     * @param {?} visible
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.handleMenuVisibilityChange = /**
     * @protected
     * @param {?} visible
     * @return {?}
     */
    function (visible) {
        if (!visible) {
            this._repopulateValue();
        }
    };
    /**
     * @protected
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype._repopulateValue = /**
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var item = this.getItemByValue((/** @type {?} */ (this.value)));
        this._field.value = item ? item.getTextContent() : '';
    };
    // Every time our value is set we need to re filter our items
    // Every time our value is set we need to re filter our items
    /**
     * @protected
     * @param {?} value
     * @return {?}
     */
    AbstractVxAutocompleteComponent.prototype.handleValueSet = 
    // Every time our value is set we need to re filter our items
    /**
     * @protected
     * @param {?} value
     * @return {?}
     */
    function (value) {
        if (value !== this.value || this.multiple) {
            this._lastNativeValue = value;
            this.setNativeValue(value);
            // If the ngControl isn't aware of this value make it aware
            if (this.lastRegisteredValue !== value) {
                this.onChangeFn(value);
            }
            this.shouldVerifyValue = true;
            this._repopulateValue();
            // Need to refilter the list if multiple is set
            if (this.multiple) {
                this.filter();
            }
            this.cdr.markForCheck();
        }
    };
    AbstractVxAutocompleteComponent.propDecorators = {
        search: [{ type: Output }],
        itemSelect: [{ type: Output }],
        _field: [{ type: ViewChild, args: ['field', { static: true },] }],
        _menu: [{ type: ViewChild, args: ['menu', { static: true },] }],
        defaultText: [{ type: Input }],
        multiple: [{ type: Input }],
        filterFunction: [{ type: Input }],
        placeholder: [{ type: Input }],
        label: [{ type: Input }],
        searchable: [{ type: Input }]
    };
    return AbstractVxAutocompleteComponent;
}(VxFormComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template E
 */
var  /**
 * @abstract
 * @template E
 */
AbstractVxPageComponent = /** @class */ (function () {
    function AbstractVxPageComponent(el, cdr) {
        this.el = el;
        this.cdr = cdr;
        this._left = false;
        this._right = false;
    }
    Object.defineProperty(AbstractVxPageComponent.prototype, "_current", {
        set: /**
         * @param {?} current
         * @return {?}
         */
        function (current) {
            /** @type {?} */
            var skipTransition = this.__current === undefined;
            if (current !== this.__current) {
                this.__current = current;
            }
            else {
                skipTransition = true;
            }
            this.position(current, skipTransition);
            this.cdr.detectChanges();
        },
        enumerable: true,
        configurable: true
    });
    return AbstractVxPageComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template P
 */
var AbstractVxPagerComponent = /** @class */ (function () {
    function AbstractVxPagerComponent(cdr) {
        this.cdr = cdr;
        this._selectedPage = 0;
        this.previousIndex = 0;
    }
    Object.defineProperty(AbstractVxPagerComponent.prototype, "selectedPage", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selectedPage;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = +value || 0;
            if (this._selectedPage !== value) {
                this.previousIndex = this.selectedPage;
                this._selectedPage = value;
                this.ensureSelectedPage();
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxPagerComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        var _this = this;
        this.pages.changes.pipe(startWith(null)).subscribe((/**
         * @return {?}
         */
        function () {
            _this.ensureSelectedPage();
            _this.cdr.markForCheck();
        }));
    };
    /**
     * @private
     * @return {?}
     */
    AbstractVxPagerComponent.prototype.ensureSelectedPage = /**
     * @private
     * @return {?}
     */
    function () {
        if (this.pages && this.pages.length) {
            if (this.selectedPage < 0) {
                this.selectedPage = 0;
                return;
            }
            else if (this.selectedPage >= this.pages.length) {
                this.selectedPage = this.pages.length - 1;
                return;
            }
            /** @type {?} */
            var selectedPage_1 = this.selectedPage;
            this.pages.forEach((/**
             * @param {?} page
             * @param {?} idx
             * @return {?}
             */
            function (page, idx) {
                page._left = idx < selectedPage_1;
                page._right = idx > selectedPage_1;
                page._current = idx === selectedPage_1;
            }));
        }
    };
    AbstractVxPagerComponent.propDecorators = {
        selectedPage: [{ type: Input }]
    };
    return AbstractVxPagerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var VX_PAGER_TOKEN = new InjectionToken('VX_PAGER_TOKEN');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
AbstractVxPagerNextDirective = /** @class */ (function () {
    function AbstractVxPagerNextDirective(pager) {
        this.pager = pager;
    }
    /**
     * @return {?}
     */
    AbstractVxPagerNextDirective.prototype._handleClick = /**
     * @return {?}
     */
    function () {
        this.pager.selectedPage++;
    };
    return AbstractVxPagerNextDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var  /**
 * @abstract
 */
AbstractVxPagerPreviousDirective = /** @class */ (function () {
    function AbstractVxPagerPreviousDirective(pager) {
        this.pager = pager;
    }
    /**
     * @return {?}
     */
    AbstractVxPagerPreviousDirective.prototype._handleClick = /**
     * @return {?}
     */
    function () {
        this.pager.selectedPage--;
    };
    return AbstractVxPagerPreviousDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var AbstractVxCheckboxComponent = /** @class */ (function (_super) {
    __extends(AbstractVxCheckboxComponent, _super);
    function AbstractVxCheckboxComponent(cdr, errorStateMatcher, control, parentForm, parentFormGroup) {
        var _this = _super.call(this, cdr, errorStateMatcher, control, parentForm, parentFormGroup) || this;
        _this.checkedChange = _this.valueChange;
        if (control) {
            control.valueAccessor = _this;
        }
        return _this;
    }
    Object.defineProperty(AbstractVxCheckboxComponent.prototype, "checked", {
        get: /**
         * @return {?}
         */
        function () {
            return this.value;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            this.value = coerceBooleanProperty(value);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxCheckboxComponent.prototype._toggleFromNative = /**
     * @return {?}
     */
    function () {
        this.setValueFromNative(!this.checked);
        return false;
    };
    /**
     * @return {?}
     */
    AbstractVxCheckboxComponent.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.checked = !this.checked;
    };
    AbstractVxCheckboxComponent.propDecorators = {
        checkedChange: [{ type: Output }],
        checked: [{ type: Input }]
    };
    return AbstractVxCheckboxComponent;
}(VxFormComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var AbstractVxVerticalExpanderComponent = /** @class */ (function () {
    function AbstractVxVerticalExpanderComponent(cdr) {
        this.cdr = cdr;
        this._expanded = false;
    }
    Object.defineProperty(AbstractVxVerticalExpanderComponent.prototype, "expanded", {
        get: /**
         * @return {?}
         */
        function () {
            return this._expanded;
        },
        set: /**
         * @param {?} val
         * @return {?}
         */
        function (val) {
            val = coerceBooleanProperty(val);
            if (val !== this._expanded) {
                this._expanded = val;
                this.animateExpansion();
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxVerticalExpanderComponent.prototype.toggle = /**
     * @return {?}
     */
    function () {
        this.expanded = !this.expanded;
    };
    /**
     * @return {?}
     */
    AbstractVxVerticalExpanderComponent.prototype.ngAfterViewInit = /**
     * @return {?}
     */
    function () {
        this.initialize();
    };
    AbstractVxVerticalExpanderComponent.propDecorators = {
        expanded: [{ type: Input }]
    };
    return AbstractVxVerticalExpanderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var AbstractVxStepComponent = /** @class */ (function (_super) {
    __extends(AbstractVxStepComponent, _super);
    function AbstractVxStepComponent(errorStateMatcher, cdr, stepper) {
        var _this = _super.call(this) || this;
        _this.errorStateMatcher = errorStateMatcher;
        _this.cdr = cdr;
        _this.stepper = stepper;
        _this.userSeenStep = false;
        _this.userLeftStep = false;
        _this._invalid = false;
        return _this;
    }
    Object.defineProperty(AbstractVxStepComponent.prototype, "stepControl", {
        get: /**
         * @return {?}
         */
        function () {
            return this._stepControl;
        },
        /** The top level abstract control of the step. */
        set: /**
         * The top level abstract control of the step.
         * @param {?} val
         * @return {?}
         */
        function (val) {
            var _this = this;
            this._stepControl = val;
            if (this.subscription) {
                this.subscription.unsubscribe();
            }
            /** @type {?} */
            var control = this.getControl();
            if (control) {
                this.subscription = control.statusChanges.subscribe((/**
                 * @return {?}
                 */
                function () {
                    // Watch for changes to the underlying control to see if we need to update the step header
                    _this.stepper._markForCheck();
                }));
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxStepComponent.prototype, "invalid", {
        get: /**
         * @return {?}
         */
        function () {
            return this._invalid;
        },
        set: /**
         * @param {?} invalid
         * @return {?}
         */
        function (invalid) {
            invalid = coerceBooleanProperty(invalid);
            if (invalid !== this._invalid) {
                this._invalid = invalid;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {?}
     */
    AbstractVxStepComponent.prototype.isValid = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var control = this.getControl();
        return this.invalid || (control ? !!(control.valid && !control.pending && this.userSeenStep) : this.userSeenStep);
    };
    /**
     * @param {?=} control
     * @param {?=} form
     * @return {?}
     */
    AbstractVxStepComponent.prototype.isErrorState = /**
     * @param {?=} control
     * @param {?=} form
     * @return {?}
     */
    function (control, form) {
        /** @type {?} */
        var originalErrorState = this.errorStateMatcher.isErrorState(control, form);
        // All child elements (because this class provides itself as an ErrorStateMatcher)
        // will use this stepper to decide if they are in an error state.
        // If we try to interact with this step mark it as invalid.
        /** @type {?} */
        var customErrorState = !!(control && control.invalid && this.userLeftStep);
        return originalErrorState || customErrorState;
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    AbstractVxStepComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        // Since basically all inputs of the stepper get proxied through the view down to the
        // underlying step-header, we have to make sure that change detection runs correctly.
        this.stepper._markForCheck();
    };
    /**
     * @return {?}
     */
    AbstractVxStepComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    };
    /**
     * @protected
     * @return {?}
     */
    AbstractVxStepComponent.prototype.getControl = /**
     * @protected
     * @return {?}
     */
    function () {
        /** @type {?} */
        var control;
        if (this.stepControl instanceof AbstractControlDirective) {
            if (this.stepControl.control) {
                control = this.stepControl.control;
            }
        }
        else {
            control = this.stepControl;
        }
        return control;
    };
    AbstractVxStepComponent.propDecorators = {
        _template: [{ type: ViewChild, args: [TemplateRef, { static: false },] }],
        label: [{ type: Input }],
        stepControl: [{ type: Input }],
        invalid: [{ type: Input }]
    };
    return AbstractVxStepComponent;
}(ErrorStateMatcher));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 */
var AbstractVxStepperComponent = /** @class */ (function () {
    function AbstractVxStepperComponent(cdr) {
        this.cdr = cdr;
        this.selectedStepChange = new EventEmitter();
        this._linear = false;
        this._selectedStep = -1;
    }
    Object.defineProperty(AbstractVxStepperComponent.prototype, "linear", {
        get: /**
         * @return {?}
         */
        function () {
            return this._linear;
        },
        set: /**
         * @param {?} value
         * @return {?}
         */
        function (value) {
            value = coerceBooleanProperty(value);
            if (value !== this.linear) {
                this._linear = value;
                this.cdr.markForCheck();
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxStepperComponent.prototype, "selectedStep", {
        get: /**
         * @return {?}
         */
        function () {
            return this._selectedStep;
        },
        set: /**
         * @param {?} stepIdx
         * @return {?}
         */
        function (stepIdx) {
            stepIdx = clampNumber(+stepIdx || 0, 0, this._steps ? this._steps.length - 1 : 0);
            if (this._steps) {
                /** @type {?} */
                var steps = this._steps.toArray();
                /** @type {?} */
                var step = steps[stepIdx];
                /** @type {?} */
                var oldStep = steps[this.selectedStep];
                if (this.selectedStep !== stepIdx) {
                    if (oldStep) {
                        oldStep.userLeftStep = true;
                    }
                    if (!step || this._shouldDisable(step)) {
                        return;
                    }
                    this._selectedStep = stepIdx;
                    this.selectedStepChange.emit(stepIdx);
                    step.userSeenStep = true;
                    this.cdr.markForCheck();
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Walks through the steps to see if we can go on to the step requested.
     */
    /**
     * Walks through the steps to see if we can go on to the step requested.
     * @param {?} stepToCheck
     * @return {?}
     */
    AbstractVxStepperComponent.prototype._shouldDisable = /**
     * Walks through the steps to see if we can go on to the step requested.
     * @param {?} stepToCheck
     * @return {?}
     */
    function (stepToCheck) {
        var e_1, _a;
        // We only disable steps if linear is true.
        if (!this.linear) {
            return false;
        }
        /** @type {?} */
        var steps = this._steps.toArray();
        try {
            for (var steps_1 = __values(steps), steps_1_1 = steps_1.next(); !steps_1_1.done; steps_1_1 = steps_1.next()) {
                var step = steps_1_1.value;
                if (step === stepToCheck) {
                    return false;
                }
                else if (!step.isValid()) {
                    return true;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (steps_1_1 && !steps_1_1.done && (_a = steps_1.return)) _a.call(steps_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    /**
     * Called by the steps when something about them changes so I can recheck
     */
    /**
     * Called by the steps when something about them changes so I can recheck
     * @return {?}
     */
    AbstractVxStepperComponent.prototype._markForCheck = /**
     * Called by the steps when something about them changes so I can recheck
     * @return {?}
     */
    function () {
        this.cdr.markForCheck();
    };
    /**
     * @return {?}
     */
    AbstractVxStepperComponent.prototype.ngAfterContentInit = /**
     * @return {?}
     */
    function () {
        this.selectedStep = 0;
    };
    AbstractVxStepperComponent.propDecorators = {
        selectedStepChange: [{ type: Output }],
        linear: [{ type: Input }],
        selectedStep: [{ type: Input }]
    };
    return AbstractVxStepperComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var VX_STEPPER_TOKEN = new InjectionToken('VX_STEPPER_TOKEN_INTERNAL');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @template ComponentType, DataType, CloseDataType
 */
var  /**
 * @template ComponentType, DataType, CloseDataType
 */
AbstractVxDialogRef = /** @class */ (function () {
    function AbstractVxDialogRef(dialog) {
        this.dialog = dialog;
        this.onClose = this.dialog.onClose.asObservable();
    }
    Object.defineProperty(AbstractVxDialogRef.prototype, "componentInstance", {
        get: /**
         * @return {?}
         */
        function () {
            return this.dialog.componentInstance;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AbstractVxDialogRef.prototype, "data", {
        get: /**
         * @return {?}
         */
        function () {
            return this.dialog.data;
        },
        enumerable: true,
        configurable: true
    });
    // This is confusing but essentially makes the data parameter optional if the CloseDataType is optional.
    // Watch https://github.com/Microsoft/TypeScript/issues/12400 to remove this need.
    // This is confusing but essentially makes the data parameter optional if the CloseDataType is optional.
    // Watch https://github.com/Microsoft/TypeScript/issues/12400 to remove this need.
    /**
     * @param {...?} data
     * @return {?}
     */
    AbstractVxDialogRef.prototype.close = 
    // This is confusing but essentially makes the data parameter optional if the CloseDataType is optional.
    // Watch https://github.com/Microsoft/TypeScript/issues/12400 to remove this need.
    /**
     * @param {...?} data
     * @return {?}
     */
    function () {
        var data = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            data[_i] = arguments[_i];
        }
        this.dialog.close((/** @type {?} */ (data[0])));
    };
    return AbstractVxDialogRef;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var ANIMATION_TIME = 300;
/** @type {?} */
var _dialogIdCounter = 0;
/**
 * @abstract
 * @template ComponentType, DataType, CloseDataType
 */
var  /**
 * @abstract
 * @template ComponentType, DataType, CloseDataType
 */
AbstractVxDialogComponent = /** @class */ (function () {
    function AbstractVxDialogComponent(resolver, injector) {
        this.resolver = resolver;
        this.injector = injector;
        this.onClose = new Subject();
    }
    /**
     * @param {?} data
     * @return {?}
     */
    AbstractVxDialogComponent.prototype._init = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        this.data = data;
    };
    /**
     * @param {?} content
     * @return {?}
     */
    AbstractVxDialogComponent.prototype._setContent = /**
     * @param {?} content
     * @return {?}
     */
    function (content) {
        /** @type {?} */
        var ref = new this.refType(this);
        if (content instanceof TemplateRef) {
            this.componentInstance = this._contentViewContainer.createEmbeddedView(content).context;
        }
        else {
            /** @type {?} */
            var factory = this.resolver.resolveComponentFactory(content);
            /** @type {?} */
            var injector = Injector.create({
                name: "vx-dialog-injector-" + _dialogIdCounter++,
                parent: this.injector,
                providers: [
                    { provide: this.refType, useValue: ref }
                ]
            });
            this.contentComponentRef = this._contentViewContainer.createComponent(factory, undefined, injector);
            this.componentInstance = this.contentComponentRef.instance;
        }
        return ref;
    };
    /**
     * @param {?} closeData
     * @return {?}
     */
    AbstractVxDialogComponent.prototype.close = /**
     * @param {?} closeData
     * @return {?}
     */
    function (closeData) {
        var _this = this;
        this.onClose.next(closeData);
        this.animateClosing();
        setTimeout((/**
         * @return {?}
         */
        function () {
            _this._selfComponentRef.destroy();
        }), ANIMATION_TIME);
    };
    /**
     * @return {?}
     */
    AbstractVxDialogComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        if (this.contentComponentRef) {
            this.contentComponentRef.destroy();
        }
        this.destroyNative();
    };
    return AbstractVxDialogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @abstract
 * @template ContainerType
 */
var  /**
 * @abstract
 * @template ContainerType
 */
AbstractVxDialog = /** @class */ (function () {
    function AbstractVxDialog(resolver, injector, appRef) {
        this.resolver = resolver;
        this.injector = injector;
        this.appRef = appRef;
    }
    /**
     * @param {?} component
     * @param {?} data
     * @return {?}
     */
    AbstractVxDialog.prototype.open = /**
     * @param {?} component
     * @param {?} data
     * @return {?}
     */
    function (component, data) {
        /** @type {?} */
        var factory = this.resolver.resolveComponentFactory(this.dialogType);
        /** @type {?} */
        var dialogRef = factory.create(this.injector);
        dialogRef.instance._init(data);
        dialogRef.instance._selfComponentRef = dialogRef;
        this.appRef.attachView(dialogRef.hostView);
        // dialogRef.changeDetectorRef.detectChanges();
        /** @type {?} */
        var result = dialogRef.instance._setContent(component);
        dialogRef.instance.open();
        return result;
    };
    return AbstractVxDialog;
}());

export { AUTOCOMPLETE_FILTER_FUNCTION, AbstractVxAttachMenuDirective, AbstractVxAutocompleteComponent, AbstractVxCheckboxComponent, AbstractVxDialog, AbstractVxDialogComponent, AbstractVxDialogRef, AbstractVxFormFieldComponent, AbstractVxFormFieldDirective, AbstractVxItemComponent, AbstractVxMenuComponent, AbstractVxPageComponent, AbstractVxPagerComponent, AbstractVxPagerNextDirective, AbstractVxPagerPreviousDirective, AbstractVxRadioButtonComponent, AbstractVxRadioGroupComponent, AbstractVxStepComponent, AbstractVxStepperComponent, AbstractVxVerticalExpanderComponent, ErrorStateMatcher, ShowOnDirtyErrorStateMatcher, VX_MENU_TOKEN, VX_PAGER_TOKEN, VX_RADIO_GROUP_TOKEN, VX_STEPPER_TOKEN, VxFormComponent, clampNumber, coerceBooleanProperty, defaultAutocompleteFilterFunction, findInArrayByDirection, formComponentMixin, VxFormComponent as ɵa, ErrorStateMatcher as ɵb };
//# sourceMappingURL=vx-components-base.js.map
